module.exports = __webpack_public_path__ + "static/hero-1b84c58e3d6803030693f8ef9c7732b8.svg";